import useNewC4Journey from 'hooks/useNewC4Journey';

const useLayoutWidth = (isOrderSummary = false) => {
  const isNewC4Journey = useNewC4Journey();

  const nonNowJourneyWidth = isOrderSummary ? 1 / 3 : 2 / 3;
  return isNewC4Journey ? 1 / 2 : nonNowJourneyWidth;
};

export default useLayoutWidth;
